import { forwardRef } from "react";
import PropTypes from "prop-types";
import SoftBoxRoot from "./SoftBoxRoot";
import { BoxProps } from "@mui/material";

interface SoftBoxProps extends BoxProps {
  variant?: "contained" | "gradient";
  bgColor?: string;
  color?: string;
  opacity?: number;
  borderRadius?: string;
  shadow?: string;
}

const SoftBox = forwardRef<HTMLDivElement, SoftBoxProps>(
  // ({ variant = "contained", bgColor = "#fff", color = "dark", opacity = 1, borderRadius = "15px", shadow = "0 0 37px rgba(8, 21, 66, 0.05)", ...rest }, ref) => (
  ({ variant = "contained", bgColor = "transparent", color = "dark", opacity = 1, borderRadius = "10px", shadow = "none", ...rest }, ref) => (
    <SoftBoxRoot
      {...rest}
      ref={ref}
      ownerState={{
        variant,
        bgColor,
        color,
        opacity,
        borderRadius,
        shadow,
      }}
    />
  )
);

SoftBox.propTypes = {
  variant: PropTypes.oneOf(["contained", "gradient"]),
  bgColor: PropTypes.string,
  color: PropTypes.string,
  opacity: PropTypes.number,
  borderRadius: PropTypes.string,
  shadow: PropTypes.string,
};

export default SoftBox;
